import {
  Box as ChakraBox,
  Flex as ChakraFlex,
  Grid as ChakraGrid,
  GridItem as ChakraGridItem,
  Text,
} from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React, { FunctionComponent } from 'react';

import { LinkType } from '../../lib/enums/LinkType';
import { OverviewItemModel } from '../../utils/types/overviewItemModel';
import { Link } from '../base/Link';
import { HyphenResult } from '../hyphen/hyphenation';

interface OverviewItemProps {
  model: OverviewItemModel[];
  enableHyphenationHeading?: boolean;
  enableHyphenationSummary?: boolean;
  type?: string;
  overrideTags?: string | undefined;
}

export const OverviewSpotAutomaticGrid: FunctionComponent<OverviewItemProps> = ({ model, overrideTags }) => {
  const router = useRouter();
  //console.log('overview spot automatic grid ', model);
  //const tagOverride =
  return (
    <ChakraFlex>
      <ChakraGrid
        templateColumns={{
          base: 'repeat(1, 1fr)',
          md: `repeat(${Math.min(model.length, 2)}, 1fr)`,
          lg: `repeat(${Math.min(model.length, 3)}, 1fr)`,
        }}
        gap={{ base: 'mobile.xl', md: 'var(--chakra-space-desktop-xl) var(--chakra-space-desktop-m)' }}
      >
        {model.map((item) => {
          return (
            <ChakraGridItem key={item.id} maxW='380px'>
              <ChakraFlex direction='column' role='group' cursor={item.link ? 'pointer' : 'default'}>
                <ChakraBox textStyle={{ base: 'mobile.body.s', lg: 'desktop.body.s' }} minH='16px'>
                  {overrideTags && overrideTags !== 'no_override' ? overrideTags : item.tag}
                </ChakraBox>
                {item.link ? (
                  <Link href={item.link} type={LinkType.Item} locale={router.locale}>
                    <ChakraBox
                      as='h3'
                      textStyle={{ base: 'mobile.h4', md: 'desktop.h4' }}
                      pt={{ base: 'mobile.s', lg: 'desktop.xxs' }}
                      pb={{ base: 'mobile.s', lg: 'desktop.xxs' }}
                      transition='color 0.2s ease'
                      _groupHover={{
                        color: 'cyan.web',
                      }}
                    >
                      {item.headline
                        ? item.enableHyphenation == 'yes'
                          ? HyphenResult(item.headline, router.locale)
                          : item.headline
                        : ''}
                    </ChakraBox>
                  </Link>
                ) : (
                  <ChakraBox
                    as='h3'
                    textStyle={{ base: 'mobile.h4', md: 'desktop.h4' }}
                    pt={{ base: 'mobile.s', lg: 'desktop.xxs' }}
                    pb={{ base: 'mobile.s', lg: 'desktop.xs' }}
                  >
                    {item.headline
                      ? item.enableHyphenation == 'yes'
                        ? HyphenResult(item.headline, router.locale)
                        : item.headline
                      : ''}
                  </ChakraBox>
                )}
                <ChakraBox textStyle={{ base: 'mobile.body.l', md: 'desktop.body.l' }}>
                  {item.text?.map((text, index) => (
                    <Text key={index}>
                      {text.body
                        ? item.enableHyphenation == 'yes'
                          ? HyphenResult(text.body, router.locale)
                          : text.body
                        : ''}
                    </Text>
                  ))}
                </ChakraBox>
                {/* <ChakraBox pt='32px'>
                  {item.link && item.linkText && (
                    <Link
                      href={item.link}
                      type={LinkType.SecondaryButton}
                      iconName='chevronRightForLink'
                      locale={router.locale}
                    >
                      {translations.common(item.linkText)}
                    </Link>
                  )}
                </ChakraBox> */}
              </ChakraFlex>
            </ChakraGridItem>
          );
        })}
      </ChakraGrid>
    </ChakraFlex>
  );
};
